import React, { Component } from "react";
import {
  Paper,
  TextField,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
  MenuItem,
  GridList,
  GridTile,
} from "material-ui";
import Loading from "../../Loading";
import LiquidFillGauge from "../TaskLiquidFill";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import formatDate from "../../../../utils/formatDate";
import diffDate from "../../../../utils/diffDate";

class TasklistReportCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      query: { startDate: "", endDate: "" },
      actual: 0,
      budgeted: 0,
      employees: [],
      completedTasks: 0,
      totalTasks: 0,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
        gridList: {
          display: "flex",
          flexWrap: "nowrap",
          overflowX: "auto",
        },
      },
    };

    this.renderEmployees = this.renderEmployees.bind(this);
  }

  componentWillMount() {
    let { startDate, endDate, id, projectId } = this.props.tasklist;
    let query = `?startDate=${startDate}&endDate=${endDate}&id=${id}&projectId=${projectId}`;
    let url = `/api/teamwork/tasklistReportCard${query}`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isLoading: false });
        this.setState({
          query: json.query,
          actual: json.actual,
          budgeted: json.budgeted,
          employees: json.employees,
          completedTasks: json.completedTasks,
          totalTasks: json.totalTasks,
        });
      });
  }

  renderEmployees() {
    let query = this.state.query;
    let startDate = new Date(query.startDate);
    let endDate = new Date(query.endDate);
    let { centerStyle } = this.state.styles;
    if (this.state.employees.length > 0) {
      return (
        <div>
          <Divider />
          <Subheader>
            Employee Hours (Last {diffDate(endDate, startDate)} days)
          </Subheader>
          <div style={centerStyle}>
            <BootstrapTable data={this.state.employees}>
              <TableHeaderColumn dataField="name" isKey>
                Name
              </TableHeaderColumn>
              <TableHeaderColumn dataField="actual" width="100">
                Hours
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Divider />
          <Subheader>Employee Hours</Subheader>
          <div style={centerStyle}>
            <center>
              <p>No recorded activity in the last 7 days</p>
            </center>
          </div>
        </div>
      );
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.color} />
          </center>
        </div>
      );
    } else {
      let { centerStyle, gridList } = this.state.styles;
      let { actual, budgeted, query, completedTasks, totalTasks } = this.state;
      let hoursComplete = budgeted > 0 ? (actual / budgeted) * 100 : 0;
      let tasksComplete =
        totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;
      let startDate = new Date(query.startDate);
      let endDate = new Date(query.endDate);
      return (
        <div>
          <Divider />
          <Subheader>Tasklist Progress</Subheader>
          <div style={centerStyle}>
            <GridList style={gridList} cols={2} cellHeight={"auto"}>
              <GridTile>
                <center>
                  <h4>Tasklist Hours</h4>
                  <LiquidFillGauge
                    radius={65}
                    color={this.props.color}
                    percentComplete={hoursComplete}
                  />
                  <h4>
                    {actual} / {budgeted}
                  </h4>
                </center>
              </GridTile>
              <GridTile>
                <center>
                  <h4>Tasklist Tasks</h4>
                  <LiquidFillGauge
                    radius={65}
                    color={this.props.color}
                    percentComplete={tasksComplete}
                  />
                  {
                    <h4>
                      {completedTasks} / {totalTasks}
                    </h4>
                  }
                </center>
              </GridTile>
            </GridList>
          </div>
          {this.renderEmployees()}
        </div>
      );
    }
  }
}

export default TasklistReportCard;



// WEBPACK FOOTER //
// ./app/components/teamwork/tasklists/TasklistReportCard.js